module.exports = __webpack_public_path__ + "static/img/5.38f64cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/5.png
// module id = Oagc
// module chunks = 1